import { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  useEffect(() => {
    document.title = "Tack för din bokning · Aminah Ådin";
    // No dataLayer push here — the booking event is pushed only when
    // Calendly confirms a real booking (see installCalendlyTracking).
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF9F6] text-[#2C2825] flex items-center justify-center px-6 py-16"
      data-testid="thankyou-page"
    >
      <div className="max-w-xl w-full text-center">
        <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-[#F3EFEA] border border-[#DCD5CE] mb-8">
          <CheckCircle2 className="h-9 w-9 text-[#8A9A86]" strokeWidth={1.5} />
        </div>

        <h1
          data-testid="thankyou-headline"
          className="font-serif-display text-4xl sm:text-5xl md:text-6xl text-[#2C2825] leading-[1.1]"
        >
          Tack för din bokning!
        </h1>

        <p
          data-testid="thankyou-message"
          className="mt-7 text-lg md:text-xl text-[#5C5651] leading-relaxed"
        >
          Din tid är bokad. Du kommer snart att få ett bekräftelsemejl från
          Calendly med alla detaljer om ditt kostnadsfria 30-minuterssamtal
          med Aminah. Välkommen – det ska bli så fint att mötas!
        </p>
      </div>
    </div>
  );
}
